export default __webpack_public_path__ + "static/media/sureshSuthar.ef940505.jpg";